import { Suggestion } from '@triumph/design-system';
import { DebtorSearchResult } from '@/app/shared/contexts/DebtorAccountContext.types';

export const mapDebtorToSuggestion = ({
  id,
  name,
  address,
}: DebtorSearchResult): Suggestion => ({
  id: id,
  value: name || '',
  category: id,
  line2: address
    ? `${address.address1 || ''}${address.address2 ? ` ${address.address2}` : ''}, ${address.city || ''}, ${address.state || ''}`
    : '',
});